// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"4708476a","239":"2f822dd7","455":"dc0f41f8","626":"be78577c","696":"b1dd016c","768":"bef101d0","977":"4288e1ed"}[chunkId] + ".chunk.js";
};